<template>
  <div class="me-page">
    <van-nav-bar title="个人中心" id="topbar" />

    <div class="me-body">
      <div class="topBg">
        <div class="headImgDiv">
          <img v-if="avartarId" class="headImg" :src="apiUrl + 'download/' + avartarId" @click="showAvatar(avartarId)"/>
          <img v-else class="headImg" src="../../assets/headPortrait.png">
        </div>
      </div>

      <van-cell-group class="me-group" :border="false">
        <van-cell title="用户资料" is-link @click="toUserInfo" />
        <van-cell title="修改密码" is-link @click="createshow = true" />
        <van-cell v-if="showModel" title="切换模式" is-link @click="handleTenantModel" />
      </van-cell-group>

      <van-cell-group class="me-group" :border="false">
        <van-cell class="logout-cell" title="退出登录" clickable @click="toLogout" />
      </van-cell-group>
    </div>

    <van-action-sheet v-model="createshow" title="密码修改">
      <div class="content">
        <van-form @submit="onCreateSubmit">
          <van-field
            v-model="oldpasswd"
            name="旧密码"
            label="旧密码"
            type="password"
            placeholder="请输入旧密码"
            :rules="[{ required: true, message: '此项必填' }]"
          />
          <van-field
            v-model="newpasswd"
            name="新密码"
            label="新密码"
            type="password"
            placeholder="请输入新密码"
            :rules="[{ required: true, message: '此项必填' }]"
          />
          <van-field
            v-model="newpasswd2"
            name="新密码"
            label="新密码"
            type="password"
            placeholder="请输入新密码"
            :rules="[{ required: true, message: '此项必填' }]"
          />
          <div class="sheet-submit">
            <van-button round block type="info" native-type="submit">保存</van-button>
          </div>
        </van-form>
      </div>
    </van-action-sheet>

    <van-action-sheet v-model="tenantModel" title="切换租户模式">
      <div class="content">
        <van-form @submit="handleChangeTenantModel">
          <van-field name="radio" label="租户模式：" class="tenant-field">
            <template #input>
              <van-radio-group v-model="showTenantModel" direction="horizontal">
                <van-radio name="SINGLE">租户模式</van-radio>
                <van-radio name="MULTI">运维模式</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <div class="sheet-submit">
            <van-button :disabled="showModelBtn" round block type="info" native-type="submit">切换模式</van-button>
          </div>
        </van-form>
      </div>
    </van-action-sheet>

    <tabular :mode="showMulAlarm ? 'manage' : 'full'" :active="showMulAlarm ? 1 : 3" />
  </div>
</template>
<script>
    import $ from '@/fly'
    import { Toast, ImagePreview } from 'vant';
    import Setting from '@/setting';
    import Tabular from '@/components/tabbar.vue';
    import { tenantData } from '@/utils/tenantUtils';
    import { mapActions } from 'vuex';
    export default {
      name: 'common-me',
      components: { Tabular },
      data () {
        return {
          createshow: false,
          newpasswd: '',
          newpasswd2: '',
          oldpasswd: '',
          apiUrl: Setting.apiBaseURL,
          avartarId: '',
          tenantModel: false,
          showTenantModel: '',
          currentTenantModel: tenantData.getTenantModel()
        }
      },
      computed: {
        showModel() {
          const roleNames = tenantData.getRoleName()
          return roleNames && (roleNames.includes("运维工程师") || roleNames.includes("管理员"));
        },
        showMulAlarm() {
          return this.showModel && this.currentTenantModel === "MULTI";
        },
        showModelBtn() {
          return this.currentTenantModel === this.showTenantModel || this.showTenantModel === '';
        }
      },
      methods: {
        ...mapActions('admin/account', [
          'logout'
        ]),
        // 头像
        showAvatar (id) {
          ImagePreview({
            images: [
              Setting.apiBaseURL + 'download/' + id
            ],
            closeable: true
          });
        },
        // 修改密码
        onCreateSubmit () {
          if (this.oldpasswd && this.newpasswd && this.newpasswd2) {
            if (this.newpasswd !== this.newpasswd2) {
              Toast('二次密码输入不一致')
            } else {
              const that = this;
              $.put('user/password', {
                originalPassword: this.oldpasswd,
                username: this.$store.state.admin.user.info.username,
                newPassword: this.newpasswd
              }).then(res => {
                if (res === 0) {
                  Toast.fail('修改失败，当前密码输入错误');
                } else {
                  Toast.success('修改成功,请重新登录');
                  that.createshow = false;
                  setTimeout(function () {
                    that.toLogout();
                  }, 1500);
                }
                that.oldpasswd = ''
                that.newpasswd = ''
                that.newpasswd2 = ''
              });
            }
          } else {
            Toast('请填写完整信息')
          }
        },
        //用户资料
        toUserInfo () {
          this.$router.push({ name: 'common-userInfo' });
        },
        // 退出登录
        toLogout () {
          this.logout();
        },
        // 选择租户
        handleTenantModel() {
          this.showTenantModel = this.currentTenantModel;
          this.tenantModel = true
        },
        handleChangeTenantModel() {
          Toast.loading({ message: '正在切换...', forbidClick: true, duration: 1000});
          setTimeout(() => {
            const tenantList = tenantData.getTenantList()
            if (this.showTenantModel === 'SINGLE') {
              const equCode = tenantList[0].equCode
              if (equCode) {
                localStorage.setItem('SHOW_TENANT', JSON.stringify(equCode))
                localStorage.removeItem('SHOW_TENANTS')
              }
            } else {
              const equCodes = tenantList.map(item => item.equCode).filter(code => code != null && code !== '').join(',');
              if (equCodes) {
                localStorage.setItem('SHOW_TENANTS', JSON.stringify(equCodes))
                localStorage.removeItem('SHOW_TENANT')
              }
            }
            tenantData.setTenantModel(this.showTenantModel);
            this.currentTenantModel = this.showTenantModel;
            this.tenantModel = false;
            this.showTenantModel = '';
          }, 1000);

        }
      },
      mounted () {
        this.avartarId = JSON.parse(localStorage.getItem('user')).avatar;
      }
    }

</script>

<style lang="less" scoped>
  /* 头部、列表、底部导航三段式，内容区自行滚动 */
  .me-page {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: #F7F7F7;
  }

  .me-body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }

  /* meBg.png 宽高比 752:516，用 padding-top 撑开，不再写死 500px */
  .topBg {
    position: relative;
    height: 0;
    padding-top: 68.6%;
    background: url(../../assets/meBg.png) no-repeat center top;
    background-size: 100% 100%;
  }

  .headImgDiv {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .headImg {
    width: 240px;
    height: 240px;
    border-radius: 50%;
    border: 15px solid #3359fa;
  }

  .me-group {
    margin-bottom: 25px;
    background-color: #FFFFFF;
    border-radius: 5px;
  }

  .logout-cell {
    text-align: center;

    ::v-deep .van-cell__title {
      color: #F65B5B;
      font-weight: bold;
    }
  }

  .tenant-field {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .sheet-submit {
    margin: 32px 16px 16px;
  }
</style>
